<template>
  <div>
    <a v-if="isValidUrl" :href="href" target="_blank">{{linkedin}}</a>
    <p v-if="!isValidUrl">{{linkedin}}</p>
  </div>
</template>

<script>
import * as utils from "@/utils/utils";

export default {
  data() {
    return {
      isValidUrl: false,
      href: null,
      linkedin: null
    };
  },
  beforeMount() {
    this.linkedin = this.params.data.linkedin;
    this.isValidUrl = utils.validURL(this.params.data.linkedin);
    if (this.isValidUrl) {
      if (
        this.linkedin &&
        (this.linkedin.indexOf("https://") == 0 ||
          this.linkedin.indexOf("http://") == 0)
      ) {
        this.href = this.linkedin;
      } else {
        this.href = "https://" + this.linkedin;
      }
    }
  }
};
</script>